import React, { useMemo } from 'react';
import { Plan, SubscriptionPlanDTO } from '@springbig/shared';
import { H4 } from '~/shared/Typography';
import { format, isBefore } from 'date-fns';

export type PlanScheduleProps = {
    plan: Plan | SubscriptionPlanDTO;
    fontWeight?: number;
    fontSize?: number;
};

export const PlanSchedule = ({
    plan,
    fontWeight = 500,
    fontSize = 14,
}: PlanScheduleProps) => {

    const generateSchedule = (): string => {
        let result = '';
        if (!plan.subscription) {
            const trial = plan.trial_period > 0 ? plan.free_trial + ' free, then ' : '';
            result = trial + plan.price;
        }
        else if (isBefore(new Date(), new Date(plan.subscription.terminated_at))) {
            const subscription = plan.subscription;
            result = 'Active until ' + format(new Date(subscription.terminated_at), 'PPP');
        }
        else {
            const subscription = plan.subscription;
            result = 'Plan renews on ' + format(new Date(subscription.next_charge_on), 'PPP');
        }

        return result;
    };

    const schedule = useMemo(() => generateSchedule(), [plan]);

    return (
        <H4
            fontWeight={fontWeight}
            fontSize={fontSize}
            textAlign={'center'}
        >
            { schedule }
        </H4>
    );
};
